<template>
  <table class="product__configurations" v-if="availableProducts.length > 0">
    <thead>
    <tr>
      <th>Header</th>
    </tr>
    </thead>
    <tbody>
    <catalog-product-grouped-product v-for="(childProduct, i) in availableProducts" :child-product="childProduct" :key="i"></catalog-product-grouped-product>
    </tbody>
  </table>
</template>

<script lang="ts">
  import {Component, Vue} from 'vue-property-decorator';
  import ServiceContainer from '@flashpointbv/solar-service-container';

  @Component(
    {
      name: 'catalog-product-grouped',
      components: {
        'catalog-product-grouped-product': ServiceContainer().getComponent('catalog-product-grouped-product')
      }
    }
  )

  export default class extends Vue {
    private get availableProducts(): Array<object> {
      return this.$store.getters['CatalogGroupedProduct/availableProducts'].sort((a, b) => (a.final_price_incl_tax > b.final_price_incl_tax) ? 1 : -1);
    }
  }
</script>
